import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageFallback } from "./PageFallback";

/**
 * Só espera a sessão terminar de ser verificada - deixa passar tanto quem tem conta quanto o
 * visitante, que navega pelo app em modo demonstração. Sem essa espera, quem tem sessão veria
 * os dados de exemplo por um instante enquanto a conta dele ainda está carregando.
 */
export function SessionRoute() {
  const { isLoading } = useAuth();
  return isLoading ? <PageFallback /> : <Outlet />;
}

/** Telas que só fazem sentido com conta (configurações, pagamento, onboarding, admin). */
export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <PageFallback />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
